import React, { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import ActionTypes from '@utils/deviceActions';
import { useTranslation } from 'react-i18next';

interface CancellationWithdrawalPayloadProps {
  action: ActionTypes.BROKER_CANCELLATION_WAIVER;
  devices: {
    msisdn: string;
  }[];
}

const useCancellationWithdrawal = (
  devices: { msisdn: string }[],
): DeviceActionProps => {
  const { t } = useTranslation('actions-modal');

  const infoMessage = useMemo(
    () => <span>{t('broker-cancellation.withdrawal-info-warning')}</span>,
    [t],
  );

  const payloadToSend = useMemo(
    (): CancellationWithdrawalPayloadProps => ({
      action: ActionTypes.BROKER_CANCELLATION_WAIVER,
      devices,
    }),
    [devices],
  );

  return {
    steps: [],
    payloadToSend,
    infoMessage,
  };
};

export default useCancellationWithdrawal;
